import React from 'react';
import { Typography } from '../../../../components';
import { EmptyStateProps } from '../types';
import { EmptyContentIc } from '../../../../components/icons';

const EmptyState: React.FC<EmptyStateProps> = ({ title, description, onAction, actionText }) => {
  return (
    <div className="bg-white rounded-5 ">
      <div className="flex flex-col items-center gap-4 justify-center py-12 px-6">
        {/* Empty State Illustration */}
        <EmptyContentIc />

        {/* Content */}
        <div className="text-center max-w-[27.5rem]">
          <div className="flex flex-col gap-1.5 items-center">
            <Typography variant="h6" className="text-auth-ink font-semibold text-xl leading-7">
              {title}
            </Typography>
            <Typography variant="body2" className="text-zinc-400 font-medium text-base leading-6">
              {description}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
